import { Card, PadlockIcon, Typography } from "@codat/orchard-ui";

import CardHeader from "../../../components/CardHeader";
import styles from "../AccountSettings.module.css";

interface ChangePasswordDisabledProps {
  isAuth0User: boolean;
}

export function ChangePasswordDisabled({
  isAuth0User,
}: ChangePasswordDisabledProps) {
  const reasonForDisablingText = isAuth0User
    ? "Your password is managed via your login provider."
    : "Your organization admin has disabled password as a sign-in method.";
  return (
    <Card className={styles.card}>
      <CardHeader title="Password" icon={<PadlockIcon />} />
      <div className={styles.disabledBlock}>
        <Typography
          variant="heading_sm"
          as="h4"
          className={styles.disabledText}
        >
          You cannot edit your password
        </Typography>
        <Typography variant="body_sm" as="p" className={styles.disabledText}>
          {reasonForDisablingText}
        </Typography>
      </div>
    </Card>
  );
}
